import { z } from "zod"

export const SlackFileSchema = z.object({
	id: z.string(),
	url: z.string(),
	name: z.string(),
	type: z.string(),
	size: z.number(),
})
export type SlackFile = z.infer<typeof SlackFileSchema>

export interface SlackEventMetadata {
	event_type: string
	event_payload: Record<string, unknown>
}
